
export function setUpRequestForms() {
    document.querySelectorAll( '.request-a-session' ).forEach( form => {
        const hiddenInput = form.querySelector( 'form [name=sessions]' );
        if ( !hiddenInput ) return console.warn( 'No hidden sessions field in contact form. Time input may not work correctly.' );

        const formSubmit = form.querySelector( '[data-cf7-form]' );
        if ( !formSubmit ) return console.warn( 'No submit button to trigger session form submission!' );

        formSubmit.addEventListener( 'click', updateChosenSessions );

        function updateChosenSessions() {
            hiddenInput.value = getChosenSessions();
        }

        function getChosenSessions() {
            let chosenSessions = "";
            const switches = form.querySelectorAll( '.switches' );
            switches.forEach( item => {
                const day = item.querySelector( '.switches__label' ).innerText;
                const times = Array.from( item.querySelectorAll( '.switches__switch input:checked' ) );
                if (times.length === 0) return;
                chosenSessions += day + ' - ' + times.map( el => el.value ).join( ', ' ) + '    ';
            } );
            return chosenSessions;
        }
    });
}

setUpRequestForms();